import React from 'react';
import { ScrollView, View } from 'react-native';
import { storiesOf } from '@storybook/react-native';
import { PanelHeader } from 'src/components/PanelHeader';
import { Group } from 'src/components/Group';
import { GroupHeader } from 'src/components/GroupHeader';
import { Separator } from 'src/components/Separator';
import { Card } from 'src/components/Card';
import { PlatformPadding } from 'src/components/PlatformPadding';

storiesOf('Card', module).add('Default', () => (
  <ScrollView>
    <PanelHeader separator={<Separator line />}>🏙 Card</PanelHeader>
    <Group header={<GroupHeader variant="secondary">Simple</GroupHeader>}>
      <PlatformPadding horizontal>
        <View>
          <Card variant="simple" style={{ height: 96, backgroundColor: '#ececec' }}></Card>
        </View>
      </PlatformPadding>
    </Group>
    <Group header={<GroupHeader variant="secondary">Elevated</GroupHeader>}>
      <PlatformPadding horizontal>
        <View>
          <Card variant="elevated" style={{ height: 96 }}></Card>
        </View>
      </PlatformPadding>
    </Group>
    <Group separator={false} header={<GroupHeader variant="secondary">Outlined</GroupHeader>}>
      <PlatformPadding horizontal>
        <View>
          <Card variant="outlined" style={{ height: 96 }}></Card>
        </View>
      </PlatformPadding>
    </Group>
  </ScrollView>
));
